import SubscriptionBar from './SubscriptionBar';
export default SubscriptionBar;



// WEBPACK FOOTER //
// ./src/components/Payments/SubscriptionBar/index.js